import { Checkboxes } from "./Checkboxes";
import { DateInput } from "./DateInput";
import { DrawingPadItem as DrawingPad } from "./DrawingPadItem/DrawingPadItem";
import { DateAndTime } from "./DateAndTime/DateAndTime";
import { Dropdown } from "./Dropdown";
import { FileUpload } from "./FileUpload/FileUpload";
import { NumberInput } from "./NumberInput";
import { Nrs } from "./Nrs";
import { ParagraphText } from "./ParagraphText";
import { RadioButtons } from "./RadioButtons";
import { SingleLineText } from "./SingleLineText";
import { StaticText } from "./StaticText";
import { Time } from "./Time";
import { VasScaleItem as VasScale } from "./VasScaleItem/VasScaleItem";

const itemComponents = {
    Checkboxes,
    Date: DateInput,
    DateAndTime,
    DrawingPad,
    Dropdown,
    FileUpload,
    Nrs,
    Number: NumberInput,
    ParagraphText,
    RadioButtons,
    SingleLineText,
    StaticText,
    Time,
    VasScale,
};

export const getItemComponent = (itemType, htmlType) => {
    if (itemType === "FileUpload" && htmlType === "drawingpad") {
        return DrawingPad;
    }

    return itemComponents[itemType];
};
